import AdditionalDocumentModal from './AdditionalDocumentModal.component';

export default AdditionalDocumentModal;